import SEO from '../components/SEO';

const TermsPage = () => (
  <main className="bg-surface min-h-screen">
    <SEO
      title="Terms & Conditions | Aspire Academy & MathMap"
      description="Terms and conditions for using Aspire Academy tuition services and the MathMap learning platform."
      path="/terms"
    />

    <div className="container-main py-16 md:py-24 max-w-3xl">
      <span className="label-uppercase text-aspire-red">Legal</span>
      <h1 className="heading-hero mt-2 mb-4">Terms &amp; Conditions</h1>
      <p className="text-gray-500 text-sm mb-10">Last updated: April 2025</p>

      <div className="space-y-8 text-gray-700 leading-relaxed">

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">1. Acceptance of Terms</h2>
          <p>
            By accessing Aspire Academy's website (aspireacademy.com.lk) or using MathMap, you agree to
            be bound by these Terms and Conditions. If you do not agree, please do not use our services.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">2. Services</h2>
          <p>Aspire Academy provides:</p>
          <ul className="list-disc pl-6 space-y-2 mt-2">
            <li>In-person and online IGCSE and A Level tuition classes in Colombo, Sri Lanka.</li>
            <li><strong>MathMap</strong> — a digital learning companion offering structured Mathematics practice, topic mapping, and progress tracking for IGCSE and A Level students.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">3. Enrolment & Fees</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>The first trial class is free and carries no obligation to continue.</li>
            <li>Session fees are payable in advance per month or per session as agreed at enrolment.</li>
            <li>Fees are subject to change with 30 days' written notice.</li>
            <li>MathMap subscription fees (if applicable) are charged monthly and renew automatically unless cancelled.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">4. Cancellation & Refunds</h2>
          <p>
            Please refer to our <a href="/return-policy" className="text-aspire-red hover:underline">Return &amp; Refund Policy</a> for
            full details on cancellations, missed sessions, and refund eligibility.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">5. Intellectual Property</h2>
          <p>
            All content on Aspire Academy's website and within MathMap — including lesson materials,
            question banks, topic maps, videos, and graphics — is the property of Aspire Academy and
            protected by copyright. You may not reproduce, distribute, or resell any content without
            prior written permission.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">6. MathMap Platform — Acceptable Use</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>MathMap accounts are for individual use only and must not be shared.</li>
            <li>You must not attempt to reverse-engineer, scrape, or copy platform content.</li>
            <li>Any misuse may result in immediate account suspension without refund.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">7. Class Recordings</h2>
          <p>
            Class recordings are made available exclusively to enrolled students for personal revision.
            Recording, downloading, sharing, or distributing class content in any form is strictly prohibited.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">8. Limitation of Liability</h2>
          <p>
            Aspire Academy is not liable for any indirect, incidental, or consequential loss arising from
            use of our services. Our liability is limited to the fees paid for the specific service in question.
            We do not guarantee specific examination results.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">9. Governing Law</h2>
          <p>
            These terms are governed by the laws of Sri Lanka. Any disputes will be subject to the
            exclusive jurisdiction of the courts of Sri Lanka.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-xl text-charcoal mb-3">10. Contact</h2>
          <p>
            For questions about these terms, contact us at{' '}
            <a href="mailto:info@aspireacademy.com.lk" className="text-aspire-red hover:underline">
              info@aspireacademy.com.lk
            </a>{' '}
            or call <a href="tel:+94743652899" className="text-aspire-red hover:underline">+94 74 365 2899</a>.
          </p>
        </section>

      </div>
    </div>
  </main>
);

export default TermsPage;
